import AddPromoAlert from '../promo/AddPromoAlert';

const AddCityRink = props => <AddPromoAlert {...props} campaignType="City Rink" />;

export default AddCityRink;
